import { portalApi } from "@services/api/portalApi";
import { StaffOid, StudentOid, TeamsMessage } from "@godalming/api-types";

export async function createAndSendMessage(recipient: string, content: string) {
	return createAndSendMultipleMessages([recipient], content);
}
export async function createAndSendMultipleMessages(
	recipients: string[],
	content: string,
) {
	const directory = (
		await portalApi.get<
			Array<{ studentNo: string; azureADObjectId: string | null }>
		>("/directory/students/communication-recipients")
	).data;
	const byId = new Map(
		directory
			.filter((student) => student.azureADObjectId)
			.map((student) => [
				student.azureADObjectId!.toLowerCase(),
				String(student.studentNo),
			]),
	);
	return sendTeamsMessage({
		requestId: crypto.randomUUID(),
		type: "oneOnOne",
		sendAs: "self",
		message: content,
		studentRecipients: recipients
			.filter((id) => byId.has(id.toLowerCase()))
			.map((id) => byId.get(id.toLowerCase())!),
		staffRecipients: recipients.filter((id) => !byId.has(id.toLowerCase())),
	});
}

export async function getAllStaffOids() {
	try {
		const response = await portalApi.get<StaffOid[]>(
			"/directory/staff/communication-recipients",
		);
		return response.data;
	} catch (error) {
		console.error("Error fetching staff OIDs:", error);
		throw error;
	}
}

export async function getAllStudentOids() {
	const response = await portalApi.get<StudentOid[]>(
		"/directory/students/communication-recipients",
	);
	return response.data;
}

export type TeamsSendRequest = TeamsMessage & {
	requestId: string;
	contentType?: "text" | "html";
	conversationLink?: import("@features/communications/types").EmailConversationLinkRequest;
};
export type TeamsSendResult = {
	sentCount: number;
	failedCount: number;
	warnings: string[];
};
export async function sendTeamsMessage(
	request: TeamsSendRequest,
): Promise<TeamsSendResult> {
	return (
		await portalApi.post<TeamsSendResult>(
			"/communications/teams-messages",
			request,
		)
	).data;
}
